// extracted by mini-css-extract-plugin
export default {"coming-soon":"styles__coming-soon___a1aZn","top":"styles__top___lx4Na","bottom":"styles__bottom___jgDHe","right":"styles__right___Yma6Q"};